export default {
  zh: {
    title: 'Dashboard名称',
    dropZone: '放置区',
    maxSlotsReached: '最多放置{num}个报告'
  },
  en: {
    title: 'Dashboard Name',
    dropZone: 'Drop Zone',
    maxSlotsReached: 'Maximum slots number is {num}'
  }
};



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/i18n.js